import './LiveUserCell.sass';

import React, { FC } from 'react';
import { UnitPhoto, UnitName } from '$shared/components';
import { LiveUserCellProps } from '$core/Live/LiveUserCell/LiveUserCell.interface';
import { useUserInfo } from '$hooks';

export const LiveUserCell: FC<LiveUserCellProps> = ({
  userId,
  onClick,
  rightContent,
}) => {
  const user = useUserInfo(userId);

  if (!user) return null;

  return (
    <div className="LiveUserCell" onClick={onClick}>
      <div className="LiveUserCell__photo">
        <UnitPhoto
          size="small"
          unit={user}
          onlineIndicator={false}
          nftIndicator={false}
        />
      </div>
      <div className="LiveUserCell__name">
        <UnitName unit={user} />
      </div>
      {!!rightContent && <div className="LiveUserCell__rightContent">{rightContent}</div>}
    </div>
  );
};
